import Vue from 'vue';
import Axios from 'axios';
// import _merge from 'lodash/merge';
// import _values from 'lodash/values';
// import _keyBy from 'lodash/keyBy';
import qs from 'qs';
import Api from '@/api/integrations.js';

export default {
  namespaced: true,
  state() {
    return {
      // Clients
      integrationsClients: [],
      isIntegrationsClientsLoading: false,
      // Installs
      integrationsInstalls: [],
      isIntegrationsInstallsLoaing: false,
      isIntegrationsInstallsLoaded: false,

      // Vacancy settings integrations
      loading: false,
      loading_module: false,
      error: null,
      integration_list: { url: [] },

      // TODO: проверить и удалить лишнее (так как интеграции были переделаны, выше верное хранилище)
      // То же относится и к mutations, getters, actions
      interview: null,
      token: null,
      item: null,
      attribute_values: [],
      sorting: {
        name: null,
        order: 'asc'
      },
      pagination: {
        pageNumber: 1,
        totalPages: 1,
        count: 50
      },
      isIntegrationStarted: false
    };
  },

  getters: {
    // integrationCode - название интеграции, например, headhunter.
    // Достаем из интеграции токен для дальнейшего обращения к интеграционному сервису или другие параметры
    getIntegrationParams: (state, getters, rootState) => integrationCode => {
      const installs = rootState.integrations.integrationsInstalls;

      if (installs.length > 0) {
        const integrationIndex = installs.findIndex(x => x.clientCode === integrationCode);

        if (integrationIndex > -1 && installs[integrationIndex].clientParams) {
          return installs[integrationIndex].clientParams;
        }
      }

      return '';
    }
  },

  mutations: {
    SET_PROP: (state, data) => {
      state[data.key] = data.v;
    },

    // key, v
    SET_ITEM: (state, v) => {
      state.item = v;
    },

    SET_TOKEN: (state, v) => {
      state.token = v;
    },

    CLEAR_INTEGRATIONS: state => {
      state.integration_list = [];
      state.loading = false;
      state.loading_module = false;
    },

    // ADD_ITEM: (state, obj) => {
    //   state.integration_list.push(obj);
    // },

    UPDATE_ITEM: (state, integration) => {
      state.integration_list = integration;
    },

    UPDATE_INTEGRATION: (state, { index, value }) => {
      Vue.set(state.integration_list.url, index, value);
    },

    // UPDATE_ITEM: (state, obj) => {
    //   let data = [];
    //   data.push(obj);
    //   state.integration_list = _values(
    //     _merge(_keyBy(state.integration_list, 'vacancy_id'), _keyBy(data, 'vacancy_id'))
    //   );
    // },

    SET_INTEGRATION_LIST: (state, v) => {
      state.integration_list = v;
    },

    SET_INTEGRATION_LIST_LINKS: (state, linksArray) => {
      state.integration_list.url = linksArray;
    },

    SET_LOADING: (state, val) => {
      state.loading = val;
    },

    SET_LOADING_MODULE: (state, val) => {
      state.loading_module = val;
    },

    SET_ERROR: (state, val) => {
      state.error = val;
    },

    FETCH_SUCCESS: (state, { data, key }) => {
      state[key] = data;
      state.loading = false;
    },

    FETCH_FAILURE: (state, err) => {
      state.error = err;
      state.loading = false;
    },

    SET_SORTING: (state, data) => {
      // Object.assign(state.sorting, data);
      state.sorting = data;
    },

    SET_PAGINATION: (state, params) => {
      state.pagination = Object.assign(state.pagination, params);
    },

    SET_ATTRIBUTE_VALUES: (state, params) => {
      state.attribute_values = params;
    },

    // New Integrations. TODO: delete all code above
    SET_INTEGRATION_CLIENTS: (state, payload) => {
      state.integrationsClients = payload;
    },

    SET_IS_INTEGRATION_CLIENTS_LOADING: (state, payload) => {
      state.isIntegrationsClientsLoading = payload;
    },

    SET_INTEGRATION_INSTALLS: (state, payload) => {
      state.integrationsInstalls = payload;
    },

    SET_IS_INTEGRATION_INSTALLS_LOADED: (state, payload) => {
      state.isIntegrationsInstallsLoaded = payload;
    },

    SET_SPECIFIC_INTEGRATION_TOGGLE_INSTALLED: (state, payload) => {
      const integrationIndex = state.integrationsClients.findIndex(x => x.id === payload.id);

      state.integrationsClients[integrationIndex].installed = payload.installed;
    },

    REMOVE_LINK_INTEGRATION: (state, link) => {
      const index = state.integration_list.url.findIndex(x => x === link);

      if (index >= 0) {
        state.integration_list.url.splice(index, 1);
      }
    },

    SET_INTEGRATION_IS_STARTED: (state, val) => {
      state.isIntegrationStarted = val;
    },

    SET_INTEGRATIONS_INSTALLS_STATUS: (state, install) => {
      // Записываем статус (обычно false) если установка в интеграционном сервисе завершена, но требуется дополнительное действие, например, установка токена или авторизация в стороннем сервисе
      // install for example { code: 'headhunter', value: false }
      const installIndex = state.integrationsInstalls.findIndex(x => x.clientCode === install.code);

      if (installIndex >= 0 && state.integrationsInstalls[installIndex].clientParams !== undefined) {
        Vue.set(state.integrationsInstalls[installIndex].clientParams, 'installStatus', install.value);
      }
    },

    CLEAR_ATTRIBUTE_VALUES: state => {
      state.attribute_values = [];
      state.pagination = Object.assign({}, state.pagination, {
        pageNumber: 1,
        totalPages: 1
      });
    }
  },

  actions: {
    async fetchAttributeValues({ commit, dispatch }, params) {
      commit('SET_LOADING', true);

      return await Api.fetchResponseAttributeValues(params)
        .then(({ data, meta }) => {
          commit('FETCH_SUCCESS', { data, key: 'attribute_values' });
          commit('SET_PAGINATION', meta);
        })
        .catch(err => {
          dispatch('global/setError', err, { root: true });
          commit('FETCH_FAILURE', err);
        });
    },

    async addIntegration({ commit }, data) {
      commit('SET_LOADING', true);
      return await Axios.post(`/v3/integration/vacancy`, data)
        .then(r => {
          commit('UPDATE_ITEM', r.data);
          commit('SET_LOADING', false);
        })
        .catch(e => {
          commit('SET_LOADING', false);
          return Promise.reject(e);
        });
    },

    async updateIntegration({ commit }, data) {
      commit('SET_LOADING', true);

      return await Axios.patch(`/v3/integration/vacancy/${data.id}`, { url: data.url })
        .then(r => {
          commit('UPDATE_ITEM', r.data);
          commit('SET_LOADING', false);
        })
        .catch(e => {
          commit('SET_LOADING', false);
          return Promise.reject(e);
        });
    },

    async fetchIntegrations({ commit }, vacancyId) {
      commit('SET_LOADING', true);

      const params = { filter: { vacancy_id: vacancyId } };

      await Axios.get(`/v3/integration/vacancy`, { params, paramsSerializer: params => qs.stringify(params) })
        .then(r => {
          // Возможно в будущем будет несколько этапов интеграций, но сейчас берется первая интеграция и в ней записано несколько ссылок в поле url
          const integrationList = r.data._embedded.vacancy_integrations[0] || { url: [] };

          commit('SET_INTEGRATION_LIST', integrationList);
        })
        .catch(e => {
          return Promise.reject(e);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    async fetchModuleInfo(context, vacancy_id) {
      return await Axios.get(`/v3/vacancy-stages/integration/${vacancy_id}`);
    },

    async updateModuleInfo({ commit }, { vacancy_id, data }) {
      commit('SET_LOADING_MODULE', true);

      return await Axios.patch(`/v3/vacancy-stages/integration/${vacancy_id}`, { ...data }).then(() => {
        commit('SET_LOADING_MODULE', false);
      });
    },

    async integrationLoad({ commit, state }) {
      return await Axios.get(`/1.0/interviews/${state.token}/integration`).then(r => {
        commit('SET_ITEM', r.data.data[0]);
      });
    },

    async integrationStart({ commit, state }) {
      return await Axios.put(`1.0/interviews/${state.token}/integration/start`).then(r => {
        commit('SET_INTEGRATION_IS_STARTED', true);
        commit('SET_PROP', {
          key: 'remaining_time',
          v: r.data.data[0].remaining_time
        });
      });
    },

    async integrationStartLink({ state }, linkId) {
      await Axios.put(`1.0/interviews/${state.token}/integration/link/${linkId}/start`);
    },

    async integrationEndLink({ state }, linkId) {
      return await Axios.put(`1.0/interviews/${state.token}/integration/link/${linkId}/end`);
    },

    async integrationEnd({ commit, state }) {
      return await Axios.put(`1.0/interviews/${state.token}/integration/end`).then(() => {
        commit('SET_INTEGRATION_IS_STARTED', false);
      });
    },

    // Новые интеграции 2022 (все что выше должно использоваться в настройках вакансии, по хорошему эти части разделить нужно на 2 файла)
    async fetchIntegrationsInstalls({ commit }) {
      commit('SET_LOADING', true);

      return await Axios.get('oauth2/installs?with[]=client')
        .then(response => {
          let integrationsInstalls = response.data._embedded.installs;

          if (integrationsInstalls.length !== 0) {
            integrationsInstalls = integrationsInstalls.map(x => {
              return {
                clientId: x.client_id,
                clientCode: x._embedded.client.code,
                clientParams: x.params
              };
            });
          }

          commit('SET_INTEGRATION_INSTALLS', integrationsInstalls);
          commit('SET_IS_INTEGRATION_INSTALLS_LOADED', true);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    async fetchIntegrationsClients({ commit }) {
      commit('SET_IS_INTEGRATION_CLIENTS_LOADING', true);

      return await Axios.get('oauth2/clients?with[]=langs.language&fields[]=installed')
        .then(response => {
          if (response.status === 200) {
            const clients = response.data._embedded.clients.filter(x => x.langs.length > 0);
            // Сортируем по флагу installed, отправляя установленные интеграции в начало
            clients.sort(a => (a.installed ? -1 : 1));

            commit('SET_INTEGRATION_CLIENTS', clients);
          }
        })
        .catch(e => {
          return Promise.reject(e);
        })
        .finally(() => {
          commit('SET_IS_INTEGRATION_CLIENTS_LOADING', false);
        });
    }
  }
};
